import React from 'react';
import { Image, OnlineLearningWrapper } from './styles';
import OnlineLearning from 'assets/school-admin/icons/online-learning.svg'

const OnlineLearningIcon = () => (
  <OnlineLearningWrapper><Image src={OnlineLearning} /></OnlineLearningWrapper>
);

export default OnlineLearningIcon;
